module.exports = __webpack_public_path__ + "static/img/fangweichaxun2023.f719245.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/fangweichaxun2023.jpg
// module id = Z6Lj
// module chunks = 0